webpackJsonp([2],{

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_style_css__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_service__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_luck_draw__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_luck_draw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_luck_draw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lib_flexible__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lib_flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lib_flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vconsole__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vconsole___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vconsole__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_proportion_directive__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_proportion_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_proportion_directive__);
/*
 * @Author: pangshuting 2723947616@qq.com
 * @Date: 2022-04-18 09:09:30
 * @LastEditors: pangshuting 2723947616@qq.com
 * @LastEditTime: 2022-06-08 16:16:14
 * @FilePath: \rotateActivity\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









//加密库
window.CryptoJS = __webpack_require__(101);
// 也可以全局引入样式


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_luck_draw___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_mint_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__util_service__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);


if (false) {
    //开发版才开启日志
    var vConsole = new Vconsole();
    Vue.use(vConsole);
}
// 控制标签宽高成比例的指令

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_proportion_directive___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp'];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
//请求发起时做拦截
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
    request.headers.set('authToken', window.sessionStorage.getItem('token')); //存放token
    request.headers.set('x_auth_token', window.sessionStorage.getItem('token'));
    request.headers.set('x_user_id', window.sessionStorage.getItem('x_user_id')); //存放memberid
    request.headers.set('x_request_platform', 'H5'); //设置请求头
});
window.onresize = setHtmlFontSize;

function setHtmlFontSize() {
    var htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    var htmlDom = document.getElementsByTagName('html')[0];
    htmlDom.style.fontSize = htmlWidth / 10 + 'px';
};
setHtmlFontSize();

//PC端UI框架
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);

// require('./util/rem.js')


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    components: {
        App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
    },
    template: '<App/>'
});

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fef2d48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(109);
function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var normalizeComponent = __webpack_require__(99)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fef2d48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 107:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(111);


var index = function index(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(248)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/index'
  }, {
    path: '/index',
    name: 'index',
    component: index
  }],
  //路由切换页面始终回到最顶部
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});
router.beforeEach(function (to, from, next) {
  // 判断是否为着陆页
  if (navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 && !sessionStorage.getItem('landingUrl')) {
    sessionStorage.setItem('landingUrl', location.href);
  }
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);





// http访问类
// debugger
var serviceIp = "https://activityapi.tupperware.com.cn" || '//' + window.location.hostname + ':8080';
var wxserviceIp = "https://wechat.tupperware.com.cn" || '//' + window.location.hostname + ':8080';

// debugger

var BaseHttp = function () {
  function BaseHttp(serviceIp) {
    var service = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BaseHttp);

    this.service = '';
    this.serviceIp = '';

    this.serviceIp = serviceIp;
    this.service = service;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(BaseHttp, [{
    key: 'getFunc',
    value: function getFunc() {
      var thiz = this;
      var func = function func(vm, url) {
        var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
        var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        var _this = this;

        var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
        var moduleName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

        if (url.indexOf('http') < 0 || url.indexOf('=http') > 0) {
          // 考虑到会把链接当成参数的情况，加入第二种情况
          url = thiz.serviceIp + thiz.service + moduleName + url;
        }
        var promise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var pro = null;
          if (method === 'POST') {
            pro = vm.$http.post(url, data, headers);
          } else if (method === 'GET') {
            pro = vm.$http.get(url, data, headers);
          } else if (method === 'PUT') {
            pro = vm.$http.put(url, data, headers);
          } else if (method === 'DELETE') {
            pro = vm.$http.delete(url, data, headers);
          }
          pro.then(function (response) {
            // Indicator.close();
            _this.disClick = false;
            if (response.data.success) {
              resolve(response);
            } else {
              // if (response.data.resultCode != '10002' && response.data.message){
              //     let message = response.data.message
              //     if(message!='已经获取过机会了'){
              //       this.$toast(message)
              //     }
              // }
              reject(response);
            }
          }, function (error) {
            // Indicator.close();
            // let message = '请求出错'
            // console.log(error)
            // setTimeout(function(){
            //   Toast({
            //     message: message,
            //     position: 'middle'
            //   });
            // },1000)
            reject(error);
          });
        });
        return promise;
      };
      return func;
    }
  }]);

  return BaseHttp;
}();

function plugin(Vue) {
  if (plugin.installed) {
    return;
  }
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
    $tupHttp: {
      // activity
      get: function get() {
        return new BaseHttp(serviceIp, '/').getFunc();
      }
    },
    $wxHttp: {
      // wechat
      get: function get() {
        return new BaseHttp(wxserviceIp, '/').getFunc();
      }
    },
    $epmsEnv: {
      get: function get() {
        return window.epmsEnv;
      }
    }
  });
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "App",
  data: function data() {
    return {};
  },

  methods: {
    // url参数解析
    getUrlParams: function getUrlParams(url) {
      var params = {};
      url = decodeURIComponent(url);
      if (url.indexOf("?") > 0) {
        var urls = url.split("?");
        sessionStorage.setItem("baseUrl", urls[0]);
        if (urls[1]) {
          var arr = urls[1].split("&");
          for (var i = 0, l = arr.length; i < l; i++) {
            var a = arr[i].split("=");
            params[a[0]] = a[1];
          }
        }
      }
      return params;
    }
  },
  created: function created() {
    var backUrl = location.href.replace(/\#\//g, ''); //替换掉`#/`
    console.log(backUrl);
    // if(backUrl.indexOf("unionid")<0){
    //     backUrl="http://localhost:8080/#/index?unionid=odWWF1h65nIMDEvZqzYSG1dzDkBM&storeCode=37360&t=1635926309318&shopId=3103/";
    // }
    var params = this.getUrlParams(backUrl);
    console.log(params);
  }
});

/***/ })

},[102]);


// WEBPACK FOOTER //
// static/js/app.e19bc87c6604f379e3ff.js